module.exports = __webpack_public_path__ + "img/1.04a66d2a.png";